import { createContext, useContext } from 'react'

const MFEContext = createContext(false)

export const MFEProvider = ({
  isMFE,
  children,
}: {
  isMFE: boolean
  children: React.ReactNode
}) => <MFEContext.Provider value={isMFE}>{children}</MFEContext.Provider>

export const useIsMFE = () => useContext(MFEContext)
